import { FC, useState } from "react";
import { Segmented } from "antd";
import { List, Calendar } from "lucide-react";
import { ScheduleListView } from "./schedule-list-view";
import { CalendarView } from "./calendar-view";

type ViewType = "list" | "calendar";

type Props = {};

export const ProjectScheduler: FC<Props> = () => {
  const [viewType, setViewType] = useState<ViewType>("list");

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Segmented
          value={viewType}
          onChange={(value) => setViewType(value as ViewType)}
          options={[
            {
              label: (
                <div className="flex items-center gap-2 px-2">
                  <List size={16} />
                  <span>List View</span>
                </div>
              ),
              value: "list",
            },
            {
              label: (
                <div className="flex items-center gap-2 px-2">
                  <Calendar size={16} />
                  <span>Calendar View</span>
                </div>
              ),
              value: "calendar",
            },
          ]}
        />
      </div>

      {viewType === "list" ? <ScheduleListView /> : <CalendarView />}
    </div>
  );
};
